/* ReactionSummaryButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "./ReactionSummaryButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef, useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { ResourcedEmoji } from '@atlaskit/emoji';
import { messages } from '../../shared/i18n';
import { Counter } from './Counter';
import { ReactionButton } from './ReactionButton';
import { Box, Flex, Inline } from '@atlaskit/primitives/compiled';
import { cx } from '@compiled/react';
var styles = {
  emoji: "_8hrz1nam",
  button: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bvu2gc",
  compactPadding: "_ca0qv77o",
  container: "_kqswh2mm"
};
/**
 * Test id for summary reaction wrapper button
 */
export var RENDER_SUMMARY_BUTTON_TESTID = 'reaction-summary-button';

/**
 * Test id for emojis displayed inside summary button. All emoji's in the summary button will have this test id
 */
export var RENDER_SUMMARY_EMOJI_TESTID = 'summary-emoji-display';

// forwardRef is used here so that the parent popup component can properly interact with the button
export var ReactionSummaryButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var emojiProvider = _ref.emojiProvider,
    _ref$reactions = _ref.reactions,
    reactions = _ref$reactions === void 0 ? [] : _ref$reactions,
    _ref$emojisToShow = _ref.emojisToShow,
    emojisToShow = _ref$emojisToShow === void 0 ? 3 : _ref$emojisToShow,
    onClick = _ref.onClick,
    _ref$showOpaqueBackgr = _ref.showOpaqueBackground,
    showOpaqueBackground = _ref$showOpaqueBackgr === void 0 ? false : _ref$showOpaqueBackgr,
    _ref$subtleReactionsS = _ref.subtleReactionsSummaryAndPicker,
    subtleReactionsSummaryAndPicker = _ref$subtleReactionsS === void 0 ? false : _ref$subtleReactionsS,
    _ref$useCompactStyles = _ref.useCompactStyles,
    useCompactStyles = _ref$useCompactStyles === void 0 ? false : _ref$useCompactStyles,
    _ref$useButtonAlignme = _ref.useButtonAlignmentStyling,
    useButtonAlignmentStyling = _ref$useButtonAlignme === void 0 ? false : _ref$useButtonAlignme;
  var intl = useIntl();

  // Helper function to sort reactions by count and return top N
  var getTopReactions = function getTopReactions(reactions, topN) {
    return _toConsumableArray(reactions).sort(function (a, b) {
      return b.count - a.count;
    }).slice(0, topN);
  };
  var totalReactionsCount = useMemo(function () {
    return reactions.reduce(function (accum, current) {
      return accum += (current === null || current === void 0 ? void 0 : current.count) || 0;
    }, 0);
  }, [reactions]);
  var topReactions = useMemo(function () {
    return getTopReactions(reactions, emojisToShow);
  }, [emojisToShow, reactions]);
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: styles.container,
    ref: ref,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(ReactionButton, {
    onClick: onClick,
    testId: RENDER_SUMMARY_BUTTON_TESTID,
    ariaLabel: intl.formatMessage(messages.summary),
    useCompactStyles: useCompactStyles,
    showSubtleStyle: subtleReactionsSummaryAndPicker,
    showOpaqueBackground: showOpaqueBackground
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    xcss: cx(styles.button, useCompactStyles && styles.compactPadding),
    testId: "reaction-summary-wrapper"
  }, topReactions.map(function (reaction) {
    return /*#__PURE__*/React.createElement(Box, {
      xcss: styles.emoji,
      testId: RENDER_SUMMARY_EMOJI_TESTID,
      style: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
        lineHeight: '12px'
      }
    }, /*#__PURE__*/React.createElement(ResourcedEmoji, {
      key: reaction.emojiId,
      emojiProvider: emojiProvider,
      emojiId: {
        id: reaction.emojiId,
        shortName: ''
      },
      fitToHeight: useCompactStyles ? 12 : 16
    }));
  })), /*#__PURE__*/React.createElement(Counter, {
    value: totalReactionsCount,
    useDarkerFont: useCompactStyles || useButtonAlignmentStyling,
    useUpdatedStyles: !useCompactStyles && useButtonAlignmentStyling
  })));
});